angular.module("Main").factory("DialogService", ["$uibModal", "$localStorage", "SessionService", "BookingService",
    function ($uibModal, $localStorage, SessionService, BookingService) {
        return {
            openRegisterDialog: openRegisterDialog
        };

        function openRegisterDialog(preis) {
            let shortRegistration = false;
            return BookingService.getRegistrationConfig().then(function (regConfig) {
                let currentProject = SessionService.currentProject();
                shortRegistration = ((currentProject === "tb" && regConfig.SperreRegistrationTB === true)
                    || (currentProject === "kb" && regConfig.SperreRegistrationKB === true) || (currentProject === "sh" && regConfig.SperreRegistrationKB === true));

                if (shortRegistration) {
                    let modalInstance = $uibModal.open({
                        templateUrl: "app/Main/views/dialogs/registerShort.html",
                        controller: "RegisterShortDialogController",
                        controllerAs: "vm",
                        backdrop: "static",
                        windowClass: 'position-class',
                        keyboard: false,
                        resolve: {data: {Preis: preis}}
                    });
                    return modalInstance.result;
                } else {
                    let modalInstance = $uibModal.open({
                        templateUrl: "app/Main/views/dialogs/register.html",
                        controller: "RegisterDialogController",
                        controllerAs: "vm",
                        backdrop: "static",
                        windowClass: 'position-class',
                        keyboard: false,
                        resolve: {data: {Preis: preis}}
                    });
                    return modalInstance.result;
                }
            })
        }
    }]);